import firebase from 'firebase/app';

import { firestore } from '../../../firebase/firebase';
import { Offer } from '../../../models/offers.model';
import { WantedListing } from '../../../models/wantedListings.model';

export const checkForMatchingWantedListings = async (
  _offer: Offer,
  tenantCompanyId: string
): Promise<WantedListing[]> => {
  try {
    console.log('checkForMatchingWantedListings called with companyId:', tenantCompanyId);

    // Pobierz WSZYSTKIE aktywne wanted listings dla firmy najemcy
    const snapshot = await firestore
      .collection('wantedListings')
      .where('companyId', '==', tenantCompanyId)
      .where('status', '==', 'active')
      .get();

    console.log('Query result:', {
      size: snapshot.size,
      empty: snapshot.empty,
    });

    const wantedListings = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as WantedListing[];

    console.log('Mapped wanted listings:', wantedListings);

    // Zwróć wszystkie aktywne ogłoszenia bez filtrowania
    return wantedListings;
  } catch (error) {
    console.error('Error checking for matching wanted listings:', error);
    return [];
  }
};

export const associateOfferWithWantedListings = async (
  offerId: string,
  selectedListingIds: string[],
  tenantUid: string
): Promise<void> => {
  if (selectedListingIds.length === 0) return;

  const batch = firestore.batch();

  for (const listingId of selectedListingIds) {
    const listingRef = firestore.collection('wantedListings').doc(listingId);

    // Dodaj ofertę do submittedOffers
    batch.update(listingRef, {
      submittedOffers: firebase.firestore.FieldValue.arrayUnion({
        offerId,
        submittedAt: new Date().toISOString(), // Używamy ISO string zamiast serverTimestamp
        submittedBy: tenantUid,
        isMatched: true, // oznacz jako dopasowane przez najemcę
      }),
      status: 'matched', // zmień status na matched
      matchedAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  await batch.commit();
};
